export const FOOTER = '© 2024 Thinkbros LLC. All Rights Reserved';
